/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ImportTask
 */
export interface ImportTask {
  /**
   *
   * @type {string}
   * @memberof ImportTask
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof ImportTask
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof ImportTask
   */
  readonly updated?: Date;
  /**
   *
   * @type {ImportTaskBroDomainEnum}
   * @memberof ImportTask
   */
  broDomain?: ImportTaskBroDomainEnum;
  /**
   *
   * @type {string}
   * @memberof ImportTask
   */
  kvkNumber?: string | null;
  /**
   *
   * @type {ImportTaskStatusEnum}
   * @memberof ImportTask
   */
  status?: ImportTaskStatusEnum;
  /**
   *
   * @type {string}
   * @memberof ImportTask
   */
  log?: string;
  /**
   *
   * @type {number}
   * @memberof ImportTask
   */
  progress?: number | null;
  /**
   *
   * @type {string}
   * @memberof ImportTask
   */
  dataOwner?: string | null;
}

/**
 * @export
 */
export const ImportTaskBroDomainEnum = {
  Gmn: "GMN",
  Gmw: "GMW",
  Gld: "GLD",
  Frd: "FRD",
  Gar: "GAR",
  Cpt: "CPT",
  Bhr: "BHR",
  Guf: "GUF",
  Gpd: "GPD",
} as const;
export type ImportTaskBroDomainEnum =
  (typeof ImportTaskBroDomainEnum)[keyof typeof ImportTaskBroDomainEnum];

/**
 * @export
 */
export const ImportTaskStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type ImportTaskStatusEnum = (typeof ImportTaskStatusEnum)[keyof typeof ImportTaskStatusEnum];

/**
 * Check if a given object implements the ImportTask interface.
 */
export function instanceOfImportTask(value: object): value is ImportTask {
  return true;
}

export function ImportTaskFromJSON(json: any): ImportTask {
  return ImportTaskFromJSONTyped(json, false);
}

export function ImportTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportTask {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    broDomain: json["bro_domain"] == null ? undefined : json["bro_domain"],
    kvkNumber:
      json["kvk_number"] === undefined
        ? undefined
        : json["kvk_number"] === null
        ? null
        : json["kvk_number"],
    status: json["status"] == null ? undefined : json["status"],
    log: json["log"] == null ? undefined : json["log"],
    progress:
      json["progress"] === undefined
        ? undefined
        : json["progress"] === null
        ? null
        : json["progress"],
    dataOwner:
      json["data_owner"] === undefined
        ? undefined
        : json["data_owner"] === null
        ? null
        : json["data_owner"],
  };
}

export function ImportTaskToJSON(json: any): ImportTask {
  return ImportTaskToJSONTyped(json, false);
}

export function ImportTaskToJSONTyped(
  value?: Omit<ImportTask, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_domain: value["broDomain"],
    kvk_number: value["kvkNumber"],
    status: value["status"],
    log: value["log"],
    progress: value["progress"],
    data_owner: value["dataOwner"],
  };
}
